import { render, staticRenderFns } from "./UpgradeLock.vue?vue&type=template&id=653b1fce&scoped=true&"
import script from "./UpgradeLock.vue?vue&type=script&lang=js&"
export * from "./UpgradeLock.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeLock.vue?vue&type=style&index=0&id=653b1fce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653b1fce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VList } from 'vuetify/lib/components/VList';
import { VListTile } from 'vuetify/lib/components/VList';
import { VListTileAvatar } from 'vuetify/lib/components/VList';
import { VListTileContent } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VAvatar,VBottomSheet,VBtn,VList,VListTile,VListTileAvatar,VListTileContent,VSubheader})
